import { GraphObject, Picture, Size, Spot } from 'gojs';
import { dataLineageButtons, LINEAGE_PARTS } from '../../../../../../../state/data-lineage-diagram';
import { buttonToolTip } from './tooltip';

const $ = GraphObject.make;

export const tableColumnsButton = (bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      name: LINEAGE_PARTS.SHOW_COLUMNS_BUTTON,
      'ButtonBorder.spot1': Spot.TopLeft,
      'ButtonBorder.spot2': Spot.BottomRight,
      'ButtonBorder.stroke': 'transparent',
      'ButtonBorder.fill': dataLineageButtons.overview.border,
      _buttonFillOver: dataLineageButtons.overview.hover.fill,
      _buttonStrokeOver: dataLineageButtons.overview.hover.border,
      _buttonFillPressed: 'transparent',
      _buttonStrokePressed: 'transparent',
      toolTip: buttonToolTip('Show Table Columns'),
      width: 20,
      height: 20,
    },
    ...bindings,
    buttonPicture(),
  );

const buttonPicture = () =>
  $(Picture, {
    source: '/assets/images/general/expand.svg',
    desiredSize: new Size(13, 8),
  });
